module.exports = __webpack_public_path__ + "static/sc_14-dbe2d0e79540daf517b33e564dac8fd0.jpg";